<template>
  <div class="advantage">
    <div class="name">我们的优势</div>
    <div class="border"></div>
    <div class="lable">专注于区块链行业 自主研发技术领先</div>
    <div class="content"  style="display: flex;justify-content: center">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="contents">
            <div><img src="./../../assets/home/advantage1.png" alt=""></div>
            <div class="name">技术领先</div>
            <div class="text">自主研发了世界领先的区块链底层核心技术，具备国内领先的自主可控区块链基础设施和平台层核心研发技术能力。</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="contents">
            <div><img src="./../../assets/home/advantage2.png" alt=""></div>
            <div class="name">成果丰富</div>
            <div class="text">专注区块链技术研发多年，拥有多个区块链基础设施平台研发经验，推出了数十个行业应用解决方案，区块链论文软著专利专著百余项。</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="contents">
            <div><img src="./../../assets/home/advantage3.png" alt=""></div>
            <div class="name">团队专业</div>
            <div class="text">国防科大博士创业团队，专注区块链技术研发，承担了相当一批国家级、央国企、民营企业的区块链平台。</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="contents">
            <div><img src="./../../assets/home/advantage4.png" alt=""></div>
            <div class="name">资质保证</div>
            <div class="text">区块链百强企业、中国区块链优秀企业最佳团队、区块链最佳技术创新奖、工信部测试证书、国产化兼容认证证书、中央网信办区块链信息服务备案等。</div>
          </div>
        </el-col>
      </el-row>




    </div>

  </div>
</template>

<script>
export default {
  name: "we-advantage",
};
</script>

<style scoped lang="scss">
.advantage{
  /*height: 570px;*/
  background-color: #FAFBFC;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 80px;
  .name {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 900;
    color: #21242A;
    line-height: 45px;
  }
  .border {
    margin: 20px auto;
    width: 27px;
    height: 3px;
    background-color: #056DFF;
  }
  .lable {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #7c7878;
    line-height: 20px;
    margin-bottom: 50px;
  }
  .content{
    margin: 64px auto 0 auto;
    max-width: 1280px;
    display: flex;

    .contents{
      .img{
        width: 91px;
        height: 93px;
      }
      .name{
        margin: 28px auto 11px auto;
        width: 73px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #50556B;
        line-height: 25px;
      }
      .text{
        margin: 0 auto;
        width: 222px;
        height: 83px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6E6D7A;
        line-height: 20px;
      }
    }
  }
}

</style>